<template>
    <el-card>
        <el-row type="flex" justify="space-between" align="middle">
            <h1 class="page-title">User Management</h1>
            <div>
                <el-button
                    data-testid="addUserButton"
                    class="page-title__add-button"
                    type="primary"
                    @click="isDialog = true"
                    icon="el-icon-plus"
                    >เพิ่มผู้ใช้งานระบบ</el-button
                >
            </div>
        </el-row>
        <el-row class="content">
            <el-col :span="24">
                <el-row>
                    <el-form
                        class="content__form"
                        @submit.native.prevent="fetchAdminUserList"
                        :inline="true"
                    >
                        <el-form-item>
                            <el-input
                                prefix-icon="el-icon-search"
                                placeholder="ค้นหาด้วยชื่อ, นามสกุล หรืออีเมล"
                                v-model="search"
                            ></el-input>
                        </el-form-item>
                        <div>
                            <el-button native-type="submit" type="primary"
                                >ค้นหา</el-button
                            >
                        </div>
                    </el-form>
                </el-row>
                <el-row class="table-content">
                    <el-col :span="24">
                        <el-table
                            v-loading="isFetching"
                            :data="userList"
                            stripe
                            style="width: 100%"
                        >
                            <el-table-column prop="firstName" label="ชื่อ">
                            </el-table-column>
                            <el-table-column prop="lastName" label="นามสกุล">
                            </el-table-column>
                            <el-table-column prop="email" label="อีเมล">
                            </el-table-column>
                            <el-table-column
                                prop="roleDescription"
                                label="ตำแหน่ง"
                            >
                            </el-table-column>
                            <el-table-column
                                prop="disable"
                                label="สถานะ"
                                #default="scope"
                            >
                                <div class="status">
                                    <div
                                        class="status__dot"
                                        :class="{ active: !scope.row.disable }"
                                    ></div>
                                    <div
                                        class="status--text"
                                        :class="{ active: !scope.row.disable }"
                                    >
                                        {{
                                            scope.row.disable
                                                ? STATUS.inactive
                                                : STATUS.active
                                        }}
                                    </div>
                                </div>
                            </el-table-column>
                            <el-table-column label="จัดการ" width="100">
                                <template #default="scope">
                                    <el-button
                                        icon="el-icon-edit"
                                        @click="onEditEmployeeClick(scope.row)"
                                    ></el-button>
                                </template>
                            </el-table-column>
                        </el-table>
                    </el-col>
                </el-row>
                <el-row
                    class="pagination-wrapper"
                    type="flex"
                    justify="space-between"
                    align="middle"
                >
                    <el-pagination
                        background
                        :current-page.sync="searchQuery.offset"
                        :page-size.sync="searchQuery.limit"
                        @current-change="fetchAdminUserList"
                        layout="prev, pager, next"
                        :total="searchQuery.total"
                    >
                    </el-pagination>
                    <div class="pagination-wrapper__option">
                        <el-select
                            @change="fetchAdminUserList"
                            v-model="searchQuery.limit"
                            placeholder=""
                            size="mini"
                            class="pagination-wrapper--select"
                        >
                            <el-option
                                v-for="item in paginateOption"
                                :key="item.value"
                                :label="item.label"
                                :value="item.value"
                            >
                            </el-option>
                        </el-select>
                        <div class="pagination-wrapper__option--text">
                            แสดง {{ fromNumber }} - {{ toNumber }} จากทั้งหมด
                            {{ searchQuery.total }} รายการ
                        </div>
                    </div>
                </el-row>
            </el-col>
        </el-row>
        <!-- Modal Dialog Employee Form -->
        <ModalEmployeeForm
            v-if="isDialog"
            data-testid="ModalEmployeeForm"
            :isEdit="isEdit"
            :dataEmployee="dataEmployee"
            :isDialog="isDialog"
            @close="isDialog = $event"
            @cancelEdit="isEdit = false"
            @isSuccess="fetchAdminUserList"
        />
    </el-card>
</template>
<script>
import ModalEmployeeForm from '@/components/employee/ModalEmployeeForm.vue'
import { STATUS } from '@/constant/userManage.js'
import userManagementApi from '@/services/fillgoods/userManagement.js'

export default {
    name: 'UserManagement',
    components: {
        ModalEmployeeForm
    },
    data () {
        return {
            isEdit: false,
            dataEmployee: {},
            STATUS,
            isDialog: false,
            isFetching: false,
            search: '',
            searchQuery: {
                offset: 1,
                limit: 10,
                // Not send to api
                total: 0,
                allPage: 0
            },
            paginateOption: [
                {
                    label: '10',
                    value: 10
                },
                {
                    label: '30',
                    value: 30
                },
                {
                    label: '50',
                    value: 50
                }
            ],
            userList: []
        }
    },
    computed: {
        fromNumber () {
            const fromNumber =
                (this.searchQuery.offset - 1) * this.searchQuery.limit + 1
            if (fromNumber > this.searchQuery.total) {
                return 1
            }
            return fromNumber
        },
        toNumber () {
            const toNumber = (this.fromNumber + this.searchQuery.limit) - 1 // decrease one
            if (toNumber >= this.searchQuery.total) {
                return this.searchQuery.total
            }
            return toNumber
        }
    },
    created () {
        this.fetchAdminUserList()
    },
    methods: {
        fetchAdminUserList () {
            this.isFetching = true
            const params = {
                limit: this.searchQuery.limit,
                offset: this.fromNumber,
                keyword: this.search
            }
            userManagementApi
                .getManageUserList(params)
                .then((response) => {
                    this.searchQuery.total = response.total
                    this.searchQuery.allPage = response.allPage
                    this.userList = response.data
                })
                .finally(() => {
                    this.isFetching = false
                })
        },
        onEditEmployeeClick (data) {
            this.isDialog = true
            this.isEdit = true
            this.dataEmployee = data
        }
    }
}
</script>
<style lang="scss" scoped>
.page-title {
    color: #232833;
    font-weight: 500;
    font-size: 24px;
    &__add-button {
        background: #367e7f;
        border-radius: 4px;
        width: 181px;
        color: #ffffff;
        display: flex;
        justify-content: space-between;
        align-items: center;
        ::v-deep .el-icon-plus {
            font-size: 16px;
        }
    }
}
.content {
    border: 1px solid #ebeef4;
    border-radius: 4px;
    margin-top: 24px;
    padding: 24px;
    &__form {
        display: flex;
        align-items: center;
        ::v-deep .el-form-item {
            margin-bottom: 0;
            &__content {
                width: 515px;
            }
        }
    }
}
.table-content {
    margin-top: 24px;
    ::v-deep .el-table__header {
        th {
            background: #000000;
            font-size: 14px;
            color: #ffffff;
            font-weight: normal;
        }
    }
    ::v-deep .el-button {
        &--default {
            background: #eff6f6;
            border: 1px solid #76abac;
            box-sizing: border-box;
            border-radius: 4px;
            i {
                color: #367e7f;
            }
        }
    }
}
.status {
    display: flex;
    align-items: center;
    &__dot {
        width: 6px;
        height: 6px;
        border-radius: 50%;
        background: #a6adbf;
        &.active {
            background: #26aa5d;
        }
    }
    &--text {
        font-weight: normal;
        font-size: 14px;
        margin-left: 12px;
        color: #a6adbf;
    }
    .active {
        color: #26aa5d;
    }
}
.pagination-wrapper {
    margin-top: 24px;

    &__option {
        display: flex;
        align-items: center;
        &--text {
            color: #82899b;
            font-weight: normal;
            font-size: 14px;
            margin-left: 16px;
        }
    }
    &--select {
        width: 70px;
    }
}
::v-deep .number {
    font-weight: normal;
    font-size: 14px;
    color: #646b7d;
    border-radius: 4px !important;
    background-color: #ffffff !important;
    &.active {
        background-color: #367e7f !important;
    }
}
::v-deep .more {
    background-color: #ffffff !important;
}
</style>
